import {
  APP_INITIALIZED, TOGGLE_NOTIFICATION, TOGGLE_SPINNER, QUOTES_FETCH_REQUESTED, QUOTES_FETCHED, QUOTES_FETCH_FAILED
} from 'utils/constants'
const initialState = {
  notificationMsg: null,
  showSpinner: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_INITIALIZED:
      const { api } = action.data;
      return { api };
    case TOGGLE_NOTIFICATION:
      return { ...state, notificationMsg: action.data.notificationMsg, showSpinner: false };
    case TOGGLE_SPINNER:
      return { ...state, showSpinner: !state.showSpinner };
    case QUOTES_FETCH_REQUESTED:
      return { ...state, ...action.data, showSpinner: true };
    case QUOTES_FETCHED:
    case QUOTES_FETCH_FAILED:
      return { ...state, ...action.data, showSpinner: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js